import React from "react";
import { Box } from "@mui/material";
import SkySparkGrid from "../../components/api/SkySparkGrid";
import ArcList from "../../components/ArcList";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DataUnavailable from "../../components/data/DataUnavailable";

const ArcsScene = () => {
  const navigate = useNavigate();
  const { siteId } = useParams();
  const [arcsValid, setArcsValid] = useState(false);
  const [arcData, setArcData] = useState([]);

  useEffect(() => {
    SkySparkGrid("testArcs(@"+siteId+")").then((response) => {
      if (response.data["rows"].length === 0) {
        setArcsValid(false);
      } else {
        setArcsValid(true);
        const responseData = response.data;
        const responseVal = responseData["rows"];
        setArcData(<ArcList dataValues={responseVal} />);
      }
    });
  }, [navigate, siteId]);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
      {arcsValid ? (
        arcData
      ) : (<DataUnavailable message="Geen arcs aanwezig in dit project"/>)
      }
    </Box>
  );
};

export default ArcsScene;
